import { Alert, Box } from '@pocketlaw/tetris';
export function Rejections(props) {
    const { rejections } = props;
    if (!rejections.length) {
        return null;
    }
    return (<Box gap="md">
      {rejections.map((rejection) => (<Alert key={rejection} appearance="danger" message={rejection}/>))}
    </Box>);
}
